import { pushEvent } from "./include/event";

(async () => {
  const elements = document.getElementsByClassName("track-click");

  Array.from(elements).forEach((element) => {
    element.addEventListener("click", () => {
      const { eventName, eventProps } = element.dataset;
      pushEvent(eventName, JSON.parse(eventProps));
    });
  });
})();
